import React from 'react';
import VideoBox from '../components/VideoBox';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 10vh 5vw; /* Adjusted padding */

  /* --- GRID SETTINGS --- */
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Forces exactly 2 columns */
  gap: 5vw; /* Space between videos */
  align-items: start;
  justify-items: center;

  /* Responsive: Switch to 1 column on mobile phones */
  @media (max-width: 768px){
    grid-template-columns: 1fr; 
    gap: 4vh;
  }
`;

const Videos = () => {

  // --- CONFIGURATION ---
  // Paste your Digital Ocean link inside the quotes below
  const digitalOceanVideo = "https://impactequipments.blr1.cdn.digitaloceanspaces.com/GalVdo3.mp4";

  // List of all 6 videos
  const videoList = [
    // Row 1: The original 2 videos
    "/videos/intro-video.mp4",
    "/videos/impact-video.mp4",

    // Row 2: New local videos
    "/videos/GalVdo1.mp4",
    "/videos/GalVdo2.mp4",

    // Row 3: New local video + The Link
    "/videos/GalVdo3.mp4",
    digitalOceanVideo 
  ];

  return (
    <Wrapper>
      {videoList.map((videoSrc, index) => (
        <VideoBox key={index} vidSrc={videoSrc} />
      ))}
    </Wrapper>
  )
}

export default Videos;